<template>
  <main class="l-main">
    <Loading variant="page" />
  </main>
</template>

<script>
import { REDIRECT_IGNORE_PATHS } from '@/constants';
import Loading from '@/components/Loading';

export default {
  components: {
    Loading
  },
  computed: {
    isAuthenticated() {
      return this.auth.isAuthenticated;
    }
  },
  created() {
    // 初回ロード時に実行したcheckSessionでログインしていない判定が出ている場合はログインページに遷移させる
    if (!this.isAuthenticated) {
      this.$router.push({ name: 'login' });
      return;
    }

    const redirectPath = localStorage.getItem('redirectPath');
    if (redirectPath) {
      this.goRedirectPath(redirectPath);
    } else {
      this.goProjects();
    }
  },
  methods: {
    goProjects() {
      this.$router.push({ name: 'projects' });
    },
    goRedirectPath(redirectPath) {
      localStorage.removeItem('redirectPath');

      // 先頭の複数のスラッシュを単一のスラッシュに置換する
      // リダイレクト除外パスのチェックをする前に置換しないと、localStorageに手動で///errorを保存した場合に/errorに遷移してしまう
      const path = redirectPath.replace(/^\/+/, '/');

      // /（スラッシュ）で始まらない場合はプロジェクト一覧に飛ばす
      if (!/^\//.test(path)) {
        this.goProjects();
        return;
      }
      // リダイレクト除外パスだった場合、プロジェクト一覧に飛ばす
      for (const regexp of REDIRECT_IGNORE_PATHS) {
        if (regexp.test(path)) {
          this.goProjects();
          return;
        }
      }
      this.$router.push({ path });
    }
  }
};
</script>
